import { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { Visibility } from "@mui/icons-material";
import styles from "../Styles/loginPage.module.css";
import {
  Button,
  Paper,
  IconButton,
  InputAdornment,
  Typography,
  Grid,
} from "@mui/material";
import { postData } from "../Services/postData";
import { getData } from "../Services/getData";
import { localUrlEnum, endpoints } from "../Utils/UrlEnum";
import { useNavigate } from "react-router-dom";
import { Vocabulary } from "../Utils/Vocabulary";
import { LoginModel } from "../Utils/Models";
import { LoginResponseType } from "../Utils/Types";
import { HttpStatusCode } from "../Utils/Constants";
import Config from "../Utils/Config";
import request from "../Utils/Request";
export default function Login() {
  const navigate = useNavigate();
  const [user, setUser] = useState<LoginModel>(new LoginModel());
  const [showPassword, setShowPassword] = useState(false);
  const [errorText, setErrorText] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      navigate(localUrlEnum.orders);
    }
  }, []);

  /**
   *
   */
  const handleSubmit = async () => {
    try {
      const response: LoginResponseType = await postData(endpoints.login, user);
      if (response && response?.data && response?.data?.userId) {
        localStorage.setItem("userId", response.data.userId);
        localStorage.setItem("userName", response.data.userName);
        localStorage.setItem("access_token", response.data.access_token);
        localStorage.setItem("userRoles", JSON.stringify(response.data.roles));
        localStorage.setItem("fullName", response.data.fullName);
        localStorage.setItem("userWorkPointId", response.data.workPointId);
        localStorage.setItem("bankAccountId", response.data.bankAccountId);

        // Store canScheduleHours if available (for instructors)
        if (response.data.canScheduleHours !== undefined) {
          localStorage.setItem("canScheduleHours", String(response.data.canScheduleHours));
        }

        // Update axios instance with token for subsequent requests
        request.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;

        // Check if user is instructor and fetch instructor details
        const isInstructor = response.data.roles.some(
          (role: any) => role.name === Config.roles.INSTRUCTOR
        );

        if (isInstructor) {
          try {
            const instructorResponse = await getData(
              `${endpoints.instructor.byUser}/${response.data.userId}`
            );
            if (instructorResponse?.data?._id) {
              localStorage.setItem(
                "userInstructorId",
                instructorResponse?.data?._id
              );
            }
          } catch (error) {
            console.warn("Could not fetch instructor details:", error);
          }
        }

        navigate(localUrlEnum.orders);
        window.location.reload();
      } else {
        setErrorText(Vocabulary.loginValidationError);
      }
    } catch (err: any) {
      if (err.response && err.response.status === HttpStatusCode.Unauthorized)
        setErrorText(Vocabulary.loginValidationError);
      else if (err.message) setErrorText(err.message);
    }
  };

  /**
   *
   * @param event
   */
  const onChangeTextField = (event: any) => {
    const newUser: any = Object.assign({}, user);
    newUser[event.target.name] = event.target.value;
    setUser(newUser);
  };

  return (
    <div className={styles.App}>
      <div className={styles.blurOverlay} />
      <Paper className={styles.loginContainer} elevation={5}>
        <Grid container spacing={1} className={styles.gridMainContainer}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className={styles.firstGrid}
          >
            <img
              src={"/sigur-la-volan.png"}
              alt="SigurLaVolan"
              width={"100%"}
            />
            <ValidatorForm className={styles.form} onSubmit={handleSubmit}>
              <TextValidator
                variant="standard"
                id="username"
                name="username"
                fullWidth
                label="Username"
                validators={["required"]}
                errorMessages={[Vocabulary.requiredField]}
                value={user.username}
                onChange={(e) => onChangeTextField(e)}
                className={styles.textfield}
              />
              <TextValidator
                variant="standard"
                id="password"
                name="password"
                type={!showPassword ? "password" : "text"}
                label={Vocabulary.password}
                fullWidth
                validators={["required"]}
                value={user.password}
                onChange={(e) => onChangeTextField(e)}
                className={styles.textfield}
                errorMessages={[Vocabulary.requiredField]}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        style={{ color: "#a5b3c0" }}
                        onClick={() => {
                          setShowPassword(!showPassword);
                        }}
                      >
                        <Visibility />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                variant="contained"
                type="submit"
                className={styles.submit}
              >
                {Vocabulary.login}
              </Button>
              <Typography className={styles.errorText}>{errorText}</Typography>
            </ValidatorForm>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}
